module.exports = __webpack_public_path__ + "static/media/ashoka.e8858455.png";